module.exports = __webpack_public_path__ + "static/media/slidingDoor90.4f434ec1.png";